import { execa, type ResultPromise } from 'execa'
import { getBpCli } from './bp-cli.js'
import { BaseCommand } from './base-command.js'

export interface BpChatCommandOptions {
  botId: string
  workspaceId: string
  credentials: {
    token: string
    apiUrl: string
  }
  projectPath?: string
}

export class BpChatCommand extends BaseCommand<never> {
  private childProcess: ResultPromise | null = null

  constructor(private options: BpChatCommandOptions) {
    super()
  }

  async run(): Promise<void> {
    const { botId, workspaceId, credentials, projectPath } = this.options

    // Get bp command path (uses bundled CLI)
    const { path: bpCommand } = await getBpCli(projectPath)

    const bpArgs = [
      'chat',
      '--botId',
      botId,
      '--workspaceId',
      workspaceId,
      '--token',
      credentials.token,
      '--apiUrl',
      credentials.apiUrl,
    ]

    this.childProcess = execa(bpCommand, bpArgs, {
      stdio: 'inherit',
    })

    try {
      // Wait for the process to complete
      await this.childProcess
    } catch (error: any) {
      // Emit error in the expected format
      this.emit('error', {
        exitCode: error.exitCode || 1,
        stderr: error.stderr || '',
        message: error.message || 'Chat command failed',
      })
      throw error
    }
  }

  kill(signal?: NodeJS.Signals | number): void {
    if (this.childProcess) {
      this.childProcess.kill(signal)
    }
  }
}
